export const notificationQueryKeys = {
  all: ["notifications"] as const,
  list: (branchId?: string) =>
    [...notificationQueryKeys.all, "list", branchId ?? "default"] as const,
  unreadCount: (branchId?: string) =>
    [...notificationQueryKeys.all, "unreadCount", branchId ?? "default"] as const,
};
